import { Typography } from '@material-ui/core'
import { Box, Tooltip } from '@mui/material'
import { DateTime } from 'luxon'
import React from 'react'
import { TableCellProps } from 'react-virtualized'

interface IDateCell extends TableCellProps {
  inputFormat?: string
  isoDate: boolean
  outputFormat?: Intl.DateTimeFormatOptions
  tooltip?: string
}

export function DateCell({ isoDate, inputFormat = '', outputFormat, tooltip, cellData }: IDateCell) {
  const date = isoDate ? DateTime.fromISO(cellData) : DateTime.fromFormat(cellData, inputFormat)

  return (
    <Box display="flex">
      <Tooltip title={tooltip}>
        <Typography>{date.toLocaleString(outputFormat ?? DateTime.DATETIME_FULL)}</Typography>
      </Tooltip>
    </Box>
  )
}
